import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';
import { $createInsertImageNode, InsertImageNode } from '../nodes/InsertImageNode';
import { $insertNodeToNearestRoot } from '@lexical/utils';

export const INSERT_IMAGE_COMMAND: LexicalCommand<string> = createCommand();

export const InsertImagePlugin: FC = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (!editor.hasNodes([InsertImageNode])) {
            throw new Error('InsertImagePlugin: InsertImageNode not registered on editor');
        }

        editor.registerCommand(
            INSERT_IMAGE_COMMAND,
            (payload: string) => {
                const insertImageNode = $createInsertImageNode(payload);
                $insertNodeToNearestRoot(insertImageNode);

                return true;
            },
            COMMAND_PRIORITY_EDITOR
        )
    }, [editor]);

    return null;
};

export default InsertImagePlugin;